/**
 * The docs hub's glyphs (DX-306), Lucide line icons like the navigation's —
 * copied from `@iconify-json/lucide` in services/developer-portal, for the
 * reason navIcons.tsx gives. Each is `aria-hidden`: the text beside it is what
 * a reader and a screen reader go by.
 */
import { ReactNode } from 'react';

const glyph =
  (children: ReactNode, size = 16) =>
  () => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );

// i-lucide-map
export const MapIcon = glyph(
  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15" />,
);

// i-lucide-scroll-text
export const ScrollIcon = glyph(
  <>
    <path d="M15 12h-5m5-4h-5m9 9V5a2 2 0 0 0-2-2H4" />
    <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" />
  </>,
);

// i-lucide-book
export const BookIcon = glyph(
  <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />,
);

// i-lucide-terminal
export const TerminalIcon = glyph(<path d="M12 19h8M4 17l6-6l-6-6" />);

// i-lucide-box
export const BoxIcon = glyph(
  <>
    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
    <path d="m3.3 7l8.7 5l8.7-5M12 22V12" />
  </>,
);

// i-lucide-file-text
export const FileTextIcon = glyph(
  <>
    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
    <path d="M14 2v5a1 1 0 0 0 1 1h5M10 9H8m8 4H8m8 4H8" />
  </>,
);

// i-lucide-sparkles
export const SparklesIcon = glyph(
  <>
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594zM20 2v4m2-2h-4" />
    <circle cx="4" cy="20" r="2" />
  </>,
);

// i-lucide-plus
export const PlusIcon = glyph(<path d="M5 12h14m-7-7v14" />);

// i-lucide-globe
export const GlobeIcon = glyph(
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20" />
  </>,
);

// i-lucide-search
export const SearchIcon = glyph(
  <>
    <path d="m21 21l-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </>,
  18,
);
